/* global jQuery */

import { Module } from 'wrapper6'
import GA4Tracking from './utils/ga4-tracking'

export default class GA4TrackingUpdateCart extends Module {
  ready (app) {
    this.addedToCart()
    this.observeCartChanges()
  }

  observeCartChanges () {
    const targetElement = jQuery('.woocommerce-cart-form');

    if (targetElement.length === 0) {
      return;
    }

    const cartElement = targetElement[0];

    let previousClasses = new Set(cartElement.classList);

    const cartObserver = new MutationObserver(() => {
      const currentClasses = new Set(cartElement.classList);

      // If processing class is removed, the cart has just been updated
      if (previousClasses.has('processing') && !currentClasses.has('processing')) {
        // There's some issues with the observer sometimes getting disconnected, so we'll just disconnect it manually and reconnect it later
        cartObserver.disconnect();
        this.trackCartUpdate();
      }

      previousClasses = currentClasses;
    });

    cartObserver.observe(cartElement, { attributes: true });
  }

  trackCartUpdate() {
    const gaAddedElement = jQuery('[data-ga-cart-update-added]');

    if (gaAddedElement.length > 0) {
      const items = JSON.parse(gaAddedElement.attr('data-ga-cart-update-added'));
      GA4Tracking.pushEvent('add_to_cart', items);
    }

    const gaRemovedElement = jQuery('[data-ga-cart-update-removed]');

    if (gaRemovedElement.length > 0) {
      const items = JSON.parse(gaRemovedElement.attr('data-ga-cart-update-removed'));
      GA4Tracking.pushEvent('remove_from_cart', items);
    }

    this.observeCartChanges();
  }

  addedToCart () {

    const gaAddToCartElement = jQuery('[data-ga-add-to-cart]');

    if (gaAddToCartElement.length === 0) {
      return;
    }

    const items = JSON.parse(gaAddToCartElement.attr('data-ga-add-to-cart'));

    GA4Tracking.pushEvent('add_to_cart', items);
  }
}
